import React, {useState} from "react";
import "./browse-layout.scss";
import {TemplateFilters} from "./template-filters/template-filters";
import {TemplatesGrid}   from "./templates-grid/templates-grid";
import {parseUrlQuery} from "@Common/utils/parse-url-query";

export const BrowseLayout = ({queryParam, categories, agentHasYearlySubscription, paywallModal, agentBenefits, templateDownloadModal, userLevels}) => {
    const [urlParams, setUrlParams] = useState(parseUrlQuery(window.location.search));
    let categoryFilters = getUniqueFilters({categoriesArray: categories, urlParams})
    const [currentPage, setCurrentPage] = useState(1);

    return (
        <div className="browse-drvn9">
            <div className="header filters-section">
                <TemplateFilters {...{queryParam, categoryFilters, urlParams, setUrlParams, setCurrentPage}} />
            </div>
            <div className="header grid-section">
                <TemplatesGrid {...{categories, currentPage, setCurrentPage, agentHasYearlySubscription, paywallModal, agentBenefits, templateDownloadModal, userLevels}} />
            </div>
        </div>
    )
}

function getUniqueFilters({ categoriesArray, urlParams }) {
    const productMap = new Map();
    const categoryMap = new Map();
    const nonCustomTemplates = Array.from(
        new Map(categoriesArray.flat().filter(t => t.relation_type != "custom").map(template => [template.template_id, template])).values()
    );
    const templates = [
        ...Array.from(nonCustomTemplates.values()),
        ...categoriesArray.flat().filter(t => t.relation_type === "custom")
    ]

    const productFilters = urlParams?.products ? new Set(urlParams.products.split('~')) : null;
    templates.forEach(item => {
        const productFamily = item.product_family_name || "Other";
        productMap.set(productFamily, (productMap.get(productFamily) || 0) + 1);
    });

    templates.forEach(item => {
        const productFamily = item.product_family_name || "Other";
        const categoryName = item.category_name;

        if (!productFilters || productFilters.has(productFamily)) {
            categoryMap.set(categoryName, (categoryMap.get(categoryName) || 0) + 1);
        }
    });

    const sortWithOtherLast = (a, b) => {
        if (a.name === "Other") return 1;
        if (b.name === "Other") return -1;
        return a.name.localeCompare(b.name);
    };

    const products = Array.from(productMap, ([name, count]) => ({
        name, key: "product_family_name", count, checked: false
    })).sort(sortWithOtherLast);

    const categories = Array.from(categoryMap, ([name, count]) => ({
        name, key: "category_name", count, checked: false
    })).sort(sortWithOtherLast);

    return { products, categories };
}

